import { COVERGO_SAAS_DEV } from "../consts.js"

export const big_policies_dev = {
	"big-policies-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "big_policies_dev",
			appId: "covergo_crm"
		},
		envConfig: COVERGO_SAAS_DEV
	}
}
